import * as React from 'react'
import { Button } from 'shared/components/Button/Button'

import { isConsole } from '../../config/config'
import { SubTask, Task, TaskStatusEnum } from './TaskList'
import { StyledCta } from './TaskList.styles'

interface TaskListCtaProps {
  task: Task | SubTask
  isReadOnly?: boolean
}

export function TaskListCta({ task, isReadOnly }: TaskListCtaProps) {
  const hasCta = task.onCtaClick && task.ctaText
  const isCompleted = task.status === TaskStatusEnum.COMPLETED
  const isInProgress = task.status === TaskStatusEnum.IN_PROGRESS

  if (task.ctaRenderer && isConsole()) {
    return <StyledCta>{task.ctaRenderer}</StyledCta>
  }

  if (task.isDisabled || isReadOnly) return null

  if (task.ctaRenderer) {
    return <StyledCta>{task.ctaRenderer}</StyledCta>
  }

  if (!hasCta) return null

  function handleClick(e: React.MouseEvent) {
    e.stopPropagation()
    task.onCtaClick?.()
  }

  if (isCompleted || isInProgress) {
    return (
      <StyledCta>
        <Button size="medium" variant="text" onClick={handleClick}>
          {task.ctaText}
        </Button>
      </StyledCta>
    )
  }

  return (
    <StyledCta>
      <Button size="medium" variant="secondary" onClick={handleClick}>
        {task.ctaText}
      </Button>
    </StyledCta>
  )
}
